import Vue from 'vue'
import vuetify from "@/plugins/vuetify";
import App from "@/App.vue";
import FlagIcon from 'vue-flag-icon'
import axios from "axios";
import i18n from "@/i18n";
import router from '@/router'
import store from "@/store";
import VueTheMask from 'vue-the-mask'
import VueSweetalert2 from 'vue-sweetalert2';
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/500.css";

import 'sweetalert2/dist/sweetalert2.min.css';
import '@/assets/css/main.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
window.axios = axios;
import Pusher from 'pusher-js';

window.Pusher = Pusher;
Vue.use(FlagIcon)
Vue.use(VueTheMask)
Vue.use(VueSweetalert2);
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (process.env.VUE_APP_DEBUG === 'true')
    store.commit('setToken', process.env.VUE_APP_API_TOKEN)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            window.localStorage.clear()
            window.location.href = '/'; // or wherever you want to redirect
        }
        return Promise.reject(error);
    }
);


new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App),
    mounted() {
        AOS.init(); // Initialize AOS
    }
}).$mount('#app')

axios.interceptors.request.use(function (config) {
    // config.headers.Authorization = "Bearer " + store.getters.token;
    config.headers.Authorization = "Bearer " + (process.env.VUE_APP_DEBUG === 'true' ? process.env.VUE_APP_API_TOKEN : store.getters.token);
    return config;
});